import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[vpViewHost]',
    standalone: false
})
export class ViewHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
